var _style, _g, _g2, _g3, _g4, _circle, _path, _circle2, _circle3, _path2, _path3, _path4, _circle4, _circle5, _path5, _g5, _path6, _g6, _polyline, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDdpiBanner1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-99 125 450 250",
    style: {
      enableBackground: "new -99 125 450 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0F0FF;}\r\n\t.st1{fill:#D6BFB7;}\r\n\t.st2{fill:#E7D6CF;}\r\n\t.st3{fill:none;stroke:#E7D6CF;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#365E47;stroke-miterlimit:10;}\r\n\t.st5{fill:#649E72;}\r\n\t.st6{fill:none;stroke:#477D5D;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st7{fill:#F5C47F;}\r\n\t.st8{fill:#FFD791;}\r\n\t.st9{fill:#D89F82;}\r\n\t.st10{fill:#C98B73;}\r\n\t.st11{fill:#E57873;}\r\n\t.st12{fill:#3B3A38;}\r\n\t.st13{fill:#6B393A;}\r\n\t.st14{fill:#FDA68A;}\r\n\t.st15{fill:#494846;}\r\n\t.st16{fill:#FFFFFF;}\r\n\t.st17{fill:none;stroke:#E8AC74;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st18{fill:#D6CDC3;}\r\n\t.st19{fill:#F5F2ED;}\r\n\t.st20{fill:#EBE7E1;}\r\n\t.st21{fill:none;stroke:#6B393A;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st22{fill:none;stroke:#CF5F66;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st23{fill:#494D54;}\r\n\t.st24{fill:#945C57;}\r\n\t.st25{fill:#CCC8E8;}\r\n\t.st26{fill:#EBBF39;}\r\n\t.st27{fill:#CB2228;}\r\n\t.st28{fill:#77B731;}\r\n\t.st29{fill:#A5C7F9;}\r\n\t.st30{fill:none;stroke:#A9C5E7;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st31{fill:#5E125E;}\r\n\t.st32{fill:#4BDD5D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJETCS"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,135.1c-35.9,9.5-68.6,34.2-89.7,66.7s-26.1,79.3-4.4,111.4c15.4,22.8,41,34.7,66.2,42.5 c70.5,21.7,145.7,18,218.3,6.6c25.2-4,50.6-8.9,74-19.7c23.4-10.8,45-27.9,57.6-51.6c12.7-23.7,15.4-53.3,7.4-79.2 c-6.3-20.4-19.7-38.9-38-47.6c-27.8-13.2-59.8-2.4-90.1-2.1c-33.9,0.4-66.6-12.4-99.2-22.7C82.6,129.2,58.6,123.1,13.1,135.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 199.7,
    cy: 332.5,
    rx: 117,
    ry: 17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 199.7,
    cy: 331.3,
    rx: 41.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 199.7,
    cy: 331.3,
    rx: 87.9,
    ry: 10.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-48.4,153.2c13,32.9,18.6,68.8,16.2,104.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-27.7,263.8c-4.2-33-1.4-67,8.1-98.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-34.5,265.1c1.3-18.5-2.2-37.3-10-54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-23.6,269.9c-2.3-16.6-0.3-33.8,5.6-49.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-14.1,216.5c-2.8-3.3-7.9-3.9-11.5-1.7c-3.6,2.2-5.7,6.7-5.4,11.1c0.3,4.4,2.7,8.4,6,11 c4,3.1,9.2,4.2,13.9,6c4.8,1.8,9.6,4.7,11.3,9.7c2.3-4.8,5.7-9,8.3-13.6c2.6-4.6,4.6-9.9,3.8-15.2c-0.8-5.5-4.9-10.4-10-12 C-2.7,210-8.7,211.7-14.1,216.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-13,217.2c9,7.3,13.4,19.7,13.4,32.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-26.4,233.8c0.4-3.9,2.1-7.6,4.8-10.2c2.7-2.7,6.4-4.3,10.2-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-10.7,241.7c0.5-5,2.7-9.8,6.1-13.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M11.5,228.3c-1.7-3.5-4.8-6.2-8.4-7.4c-3.6-1.1-7.7-0.7-11,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M5.1,242.6c-1.5-1.6-3.5-2.7-5.6-3.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-42.5,204.1c-3.4-5.1-9.9-7.2-15.2-5c-5.8,2.5-9.4,9.4-10.3,16.4s0.4,14,1.7,20.9 c5.7-3.5,11.7-6.4,18-8.4c3.6-1.2,7.2-2.1,10.6-3.9c3.4-1.7,6.6-4.4,8.2-8.1c1.7-3.7,1.5-8.7-1-11.8 C-33,201-38,200.8-42.5,204.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-65.8,235.1c1.9-6.3,4.4-12.4,8.1-17.9c3.7-5.4,8.5-10.1,14.4-12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-29.3,213.6c-0.6-2.6-2.6-4.7-4.9-5.9c-2.3-1.2-5-1.4-7.6-1.2c-2.6,0.2-5.1,1.1-7.6,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-47.4,206.7c-1.4-2.1-3.5-3.8-5.8-4.7c-2.4-0.9-5-1-7.4-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-43.5,224.8c-0.4-2.9-1.8-5.6-3.8-7.6c-2-2-4.8-3.3-7.6-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-67.5,221.8c0.3-2.4,1.8-4.6,3.8-5.8c2.1-1.1,4.7-1.2,6.8-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-57.6,230.3c-0.2-2.6-1.7-5.1-4-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-66.6,229.5c1-1,2.3-1.8,3.6-2.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-20.8,161.6c-4.5-0.7-9.4,1.7-11.4,5.9s-0.9,9.8,2.7,12.7c3.2,2.5,7.4,2.6,11.4,2.7 c4.7,0,9.4,0.1,14,1.1s9.1,3.1,12.2,6.8c0.9-12.3-6-24.8-16.8-30.4c-2-1-4.2-1.8-6.4-1.7C-17.2,158.7-19.4,160-20.8,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M7.9,189.5c-1.7-6.8-5.3-13.1-10.2-18c-5-4.8-11.3-8.2-18-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-29.5,178.3c1.5-6.7,6.3-12.6,12.5-15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-12.5,182c-0.9-5.3,1.2-11,5.4-14.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2.1,184.8c-0.9-2.2-0.6-4.9,0.8-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M4.3,174.3c-1.2-0.8-2.8-0.9-4-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-8.4,161.3c-1.6,0.4-3.1,1.6-3.6,3.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-45.8,150.7c3.5-0.9,7.2,2.1,7.8,5.8c0.6,3.6-1.4,7.4-4.3,9.6c-2.9,2.2-6.6,3-10.2,3.2 c-3.6,0.2-7.2-0.2-10.8-0.2c-7.7,0-15.4,1.9-22.3,5.5c2.5-8,7.6-15.1,14.4-19.8C-64.3,150.1-56,147.9-45.8,150.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-51.5,150c4.1,4.5,6,11,5.1,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-60.1,168.7c0.2-5.9-2.7-11.9-7.4-15.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-74.9,170c0.2-3-1.1-6-3.3-7.9"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "7.3,252.5 -3.8,303.4 -5.2,310 -55,310 -65.6,252.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M7.3,252.5l-11.1,50.8h-36.3c-5.3,0-9.8-4.5-11-10.8l-7.3-40H7.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M141.9,310.8c-5.2,7.2-11.7,12.4-18.8,16.3c-5.6,3-11.5,5.3-17.4,7c-8,2.3-17.9,3.9-28.6,4.6 c-28.9,1.8-63.4-3.4-79.4-21.1c-17.3-19.1-23.1-44.2-7.7-80.9c5-11.9,12.2-25,22-39.6c15.3-22.8,47.8-38,74.5-22.5 c15.2,8.8,20.6,20.7,20.2,34.5c-0.4,13.8,6.5,24.5,15.5,31.3c0.5,0.4,1,0.7,1.5,1.1c8.7,6.3,18.3,11.5,23.7,21.9 C154.8,277.8,151.2,298.1,141.9,310.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M147.3,263.4c-5.4-10.4-15.1-15.6-23.7-21.9c-8.3-3.1-16-7.7-19.7-15.5c-3.8-7.9-2.7-17.4-5.6-25.7 c-4.4-12.3-20-24.5-32-18.2c-29.1,15.3-48,48.2-46.6,81.1c0.5,10.4,3.3,21.5,11.5,27.8c6.7,5.1,15.5,6.1,23.9,6.5 c17.1,1,34.2,0.6,51.3-1c4.9-0.5,10-1,14.7,0.4c4.7,1.5,9,5.6,8.9,10.5c-0.1,4.6-3.8,8.3-7.5,11.1c-7.1,5.4-15.5,9.1-24,11.3 c-21.6,5.6-43.8,2.7-65.3-3.3c-13-3.6-26.1-9.1-35.2-19.2c-11.6-12.8-15-31.4-13-48.5c0.9-7.6,2.7-15.1,5-22.3 c-15.4,36.7-9.6,61.8,7.7,80.9c16,17.7,50.4,22.9,79.4,21.1c10.7-0.7,20.6-2.3,28.6-4.6c0.8-0.2,1.5-0.5,2.3-0.7 c0.4-0.1,0.9-0.3,1.3-0.4c0.3-0.1,0.7-0.2,1-0.3c0.5-0.2,0.9-0.3,1.4-0.5c0.3-0.1,0.6-0.2,0.9-0.3c0.5-0.2,1-0.4,1.5-0.6 c0.3-0.1,0.6-0.2,0.8-0.3c0.5-0.2,1-0.4,1.5-0.6c0.3-0.1,0.6-0.2,0.8-0.4c0.5-0.2,0.9-0.4,1.4-0.6c0.3-0.1,0.6-0.3,0.9-0.4 c0.4-0.2,0.9-0.4,1.3-0.6c0.5-0.2,1-0.5,1.4-0.7c0.3-0.1,0.5-0.3,0.8-0.4c0,0,0,0,0,0l0,0c7.1-3.9,13.7-9.1,18.8-16.3 C151.2,298.1,154.8,277.8,147.3,263.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M177.7,312.2c1.4,0.9,4.2,6,8.6,8.2c3.1,1.5,10.7,1,20.5,2.5c0.8,0.1,1.6,0.2,2.2,0.7 c1.1,0.9,1.1,2.7,0.4,3.9c-0.8,1.2-2.1,1.9-3.4,2.6c-9,4.2-18.4,4.2-20.3,4.8c-2.6,1-4.2,3.1-6.9,2.9 c-2.4-0.2-3.9-2.6-4.5-4.9c-0.6-2.6-0.6-3.5-1.3-5.7c-4.5-4.7-6.4-8.1-6.1-12.6C170.6,313,172.6,314.3,177.7,312.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M83.6,247.4c18.5,1,54.4,4.7,59.9,7c7.9,3.4,29.8,37.7,43,59.8c-5,4.5-10.5,8.4-15.9,11.4 c-10.6-14.9-22-29.1-33.2-41.7c-20.5-4.2-41.4-6.6-62.3-7C73.9,267.5,74.7,255.6,83.6,247.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M64.5,144.1c-4.6,4.6-5.5,15.7-5.2,21.5c0.3,5.9,0.4,12.3-3.2,16.9c-2.3,3-5.9,4.8-8.6,7.4 c-5.5,5.4-6.8,14.2-3.9,21.3c2.8,7.1,9.4,12.4,16.7,14.6c7.3,2.2,15.3,1.6,22.6-0.9c7.2-2.4,14.4-7.5,15.7-15 c1.3-8.1-4.7-15.7-4.6-23.9c0.1-4.9,2.3-9.4,4-13.9c1.8-4.5,4.1-18.9,2.1-20.6c-4.7-3.8-8.6-2.6-14.5-3.8 C79.5,146.5,75.5,142.3,64.5,144.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M186.3,312.2c2.7,2.1,5.4,4.2,8.1,6.1c9.5-2.8,8.8-2.1,18.3-5c0.7-0.2,1.5-0.4,2.3-0.3 c1.4,0.3,2.2,2,2,3.4c-0.2,1.4-1.1,2.7-2,3.8c-6.3,7.6-14.9,11.5-16.4,13c-2,2-2.5,4.6-5.1,5.6c-2.2,0.9-4.8-0.5-6.1-2.6 c-1.3-2-1.6-4.5-1.7-6.2c-2.9-2.8-6.1-5.2-8.7-7.4C179.8,319.4,182.6,316.2,186.3,312.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M46.2,240.8c-2.7,6.9-6.8,11.7-7.6,25.4c-0.8,13.8,8.6,24.3,24.6,26.3c18.5,2.3,38.5-1.8,56.6-2.1 c3.1,0,6,0.9,8.6,2.6c19.3,13.4,32.4,24.8,52,36.9c1.9-5.4,3.5-10.4,9.6-16.2c-19.1-20-33.5-30.4-54.4-47.5 c-2.8-2.3-6.2-3.7-9.8-4c-13.7-1.1-28.2,0.1-41-2.7c0.9-4.2,2.7-13.9,2.2-17.4C72.9,240.3,59.5,237,46.2,240.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M76.3,199.5c0.5,0.6,1,1.1,1.8,1.2c0.8,0.1,1.5-0.5,2-1.1c2.7-2.9,4.6-6.5,5.3-10.1 c-0.7-0.4-1.3-0.8-1.9-1.1c-0.5-0.3-1-0.8-1.2-1.3c-0.2-0.4-0.2-0.8-0.2-1.2c0.4-3.6,0.7-5.6,2-9.3c-6.1-1.4-11.8-3-15-5.7 c-0.4,1.7-0.9,5-1.9,8.3c-1.1,3.5-2.8,6.9-5.6,8.4C67.2,190.7,72.2,194.8,76.3,199.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M48.6,194.3c-3.7,4.8-5.8,40.8-4,50.7c12.1,5.6,29.7,4.9,43,2.1c-0.3-6.9,1.9-18.8,3.8-23.8 c2.8-9.3,4.7-13.4,7-26.1c-4.1-2.8-9.1-5.6-12.9-7.8c-0.7,3.7-2.5,7.2-5.3,10.1c-0.5,0.6-1.2,1.1-2,1.1 c-0.8-0.1-1.3-0.7-1.8-1.2c-4.1-4.7-9.1-8.8-14.7-12.1c-0.2,0.1-0.4,0.2-0.7,0.3C52.8,190.9,50.6,191.8,48.6,194.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M82.1,185.8c0,0.4,0,0.8,0.2,1.2c-3.6,4.3-11.6-1.3-15.1-8c1-3.3,1.5-6.6,1.9-8.3c3.3,2.7,9,4.4,15,5.7 C82.9,180.1,82.5,182.2,82.1,185.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.4,197.3c3.1,2.8,3.9,38.3,6.2,40.4c1.3,1.1,16.3,8.8,24.6,12.9c-2.9,1.8-5.4,4.1-7.6,6.8 c-9.6-1.6-24-5.6-27.4-8.2c-4.3-3.2-4.4-23.3-5.6-35.2C91.4,208.6,92.5,202.7,98.4,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M97.2,255.3c-3.2,1.3-3.4,1.4-6.4-0.4c-2.6-1.7-4.7-3.5-4.7-8.9c0-18.2,3-40-2.3-57.5 c4.9,2.7,9.4,4.6,13.6,7.8c1.3,0.9,1.6,2.5,1.6,4.1C99.1,231.1,98.3,236.2,97.2,255.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M98,201c-1,14.8-0.8,29.5-1.8,45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M97.4,221.2c1.5-1.5,2.5-3.3,3.1-5.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "79.6,259.8 79.5,262.2 111.5,262.9 154.1,258.7 154.3,255.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.5,259.8 140,252.6 146.5,256.4 111.3,260.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "182.5,218.6 181,216.8 133.9,218.6 110,260.1 111.2,261.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "134.8,220.1 111.2,261.3 156.3,257 182.5,218.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M93.5,164.4c3-1.5,6.4-0.8,7.6,1.5c1.2,2.4-0.3,5.5-3.3,7.1c-3,1.5-6.4,0.8-7.6-1.5 C89,169.1,90.5,166,93.5,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.5,157.5c-0.6,4-2.3,8.3-4.9,13.2c-0.9-3.9-1.5-8.8-2.3-13.6c-0.8-4.8-1.8-9.6-3.6-13.6 c-0.4-0.9-0.8-1.7-1.3-2.5c1.1-0.1,2.1,0,3.2,0.3c1.6,0.4,3.1,1.3,4.3,2.4c2,1.8,3.4,4.3,4.2,6.9 C100.8,152.7,100.9,155,100.5,157.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M97.5,161.6c0,0.8-0.1,1.6-0.1,2.4c-1.1,12.8-6.5,21.6-14.7,21.6c-11.6,0-19.2-13-19.2-25.8 c0-12.6,7.7-21.7,16.8-20.7c5.2,0.6,9,2.3,11.7,4.9c1.8,1.7,3.1,3.7,4,6c1,2.6,1.5,5.5,1.6,8.7c0,0,0,0,0,0 C97.6,159.6,97.6,160.6,97.5,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M97.5,161.6c-0.3-1.2-0.9-2.4-1.6-3.5c-6.9,3.6-15,5-22.8,3.7c-1.5,1.2-2.9,2.4-4.4,3.6 c0-5.8,0.1-9.8,2.4-12.6c2.1-2.6,5.7-3.6,9.1-4.1c3.8-0.5,7.7-0.5,11.5,0.1c1.4,0.2,3,0.5,4.2,1.2c1,2.6,1.5,5.5,1.6,8.7 c0,0,0,0,0,0C97.6,159.6,97.6,160.6,97.5,161.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.2,153.7c-1.6,1.4-3.6,2.5-5.8,3.4c-6.4,2.6-14.7,3.4-21.2,3.1c-3.2,7-4.5,9.5-5.3,15.6 c-3.1-2.9-5.6-8.3-6.4-12.5c-0.7-4.2-0.7-8.6,0.5-12.7c1.8-6.5,6.5-10,9.7-11.6c0.8-0.4,1.5-0.7,2.1-1 c4.1-1.6,8.7-1.4,12.9-0.2c2.3,0.7,4.2,1.9,5.9,3.4c3.3,3,5.3,7,6.6,10C98.6,152.2,98.9,153,99.2,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M60.5,167.8c1.2-2.4,4.7-3,7.6-1.4c3,1.6,4.4,4.7,3.2,7.1c-1.2,2.4-4.7,3-7.6,1.4 C60.7,173.3,59.3,170.2,60.5,167.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M75.9,165.3c2.2-1.2,4-2,6.5-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M90.4,165c1.8-1.4,4.2-1.1,5.6,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M87.9,170.5c0.2,1.9,0.1,3.9-0.4,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M86.2,179.1c-3,0.4-5-0.5-6.6-2.7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 80,
    cy: 170.9,
    rx: 0.9,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 91.9,
    cy: 170.9,
    rx: 0.9,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M100.5,157.5c-0.3-1.4-0.7-2.8-1.2-4.1c-0.3-0.7-0.7-1.5-1.1-2.2c-1.5-2.3-3.6-4.2-6.2-5 c-0.7-1-1.5-1.9-2.3-2.8c-2.9-3-6.3-4.7-10-5.2c-3-0.5-6.2-0.2-9,0.8c0.8-0.4,1.5-0.7,2.1-1c4.1-1.6,8.7-1.4,12.9-0.2 c2.3,0.7,4.2,1.9,5.9,3.4c1.6,0.4,3.1,1.3,4.3,2.4c2,1.8,3.4,4.3,4.2,6.9C100.8,152.7,100.9,155,100.5,157.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M63.3,186.2c4.5,3.2,5.7,9.4,6.2,14.9c1.7,15.8,1.5,31.8-0.4,47.6c-0.4,3.2-0.9,6.5-2.8,9.1 c-2.4,3.3-6.6,4.8-10.6,5.7c-6.1,1.3-12.4,1.7-19.2,0.5c4.9-13.6,7-26.5,6.4-40.9c-0.3-6.5-0.1-12.3,0.5-18.9 C44.3,194.4,51.7,190.3,63.3,186.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M90,248.8c3.6-1.1,7.2-2.3,11-3.5c3.6-0.5,7.4,0.6,10.1,3.4c0.9,1.6,1.4,3.5,1.5,5.3 c0,0.4,0,0.8-0.1,1.2c-0.1,0.4-0.4,0.7-0.8,0.8c-0.4,0.1-0.9-0.2-1.2-0.6c-0.3-0.4-0.4-0.8-0.5-1.3 c-0.5-1.7-1.4-3.2-2.6-4.7c0.8,2,0.8,4.3,0.7,6.5c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.8,0.7-1.2,0.5c-0.5-0.2-0.6-0.8-0.7-1.2 c-0.4-1.7-0.7-3.4-0.9-5.4c0,1.9,0,3.8-0.1,5.7c0,0.6-0.1,1.3-0.6,1.7c-0.3,0.3-0.8,0.4-1.2,0.3c-0.4-0.1-0.8-0.5-0.9-0.9 c-0.1,0.4-0.2,0.8-0.5,1.2c-0.3,0.3-0.8,0.5-1.2,0.4c-0.4-0.2-0.6-0.7-0.7-1.1c-0.2-1.1-0.4-2.2,0-3 c-1.7,1-3.7,1.5-5.7,1.3c-2-0.2-3.9-1-5.1-2.3C89,252.5,89.5,250.5,90,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.9,193c-2.9,1.5-4.9,4.4-5.9,7.5c-1,3.1-1.1,6.4-1.1,9.7c0.1,14.6,2,37.3,8.2,40.9 c7.5,4.4,25.7,6.7,39.6,6.3c-0.3-2.9-0.9-6.2,1.1-9.1c-11.5-1.6-25.9-6.8-28.3-9.2c-2.8-2.8-0.8-22.5-3.5-36 C59.2,199.1,56,194.1,49.9,193z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M58.6,198.7c3.1,13.4,3.3,37,4.8,40.6c0.6,1.6,3.9,2.7,5.9,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M61.5,218c2.1-3.9,2.7-6.2,3.3-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M43.9,220.2c1.1,8.4,1.8,13.8,2.8,18.8c1.3,7.2,1.5,10.9,4.1,13.5c1.9,1.9,9.8,2.2,15.8,2.9"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M94.3,307.3c-23.9-18-55.9-24.7-85-17.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M58.5,297.1c-11.4-16.5-32-26.1-51.1-23.1c-0.7,10.1,6,19.7,14.9,24.4C31.2,303.1,41.8,303.7,58.5,297.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M51.1,299.9c8.5-6.1,19.2-8.9,29.6-7.8c10.4,1.2,20.3,6.3,27.2,14.5C89.9,311.4,70.4,310.7,51.1,299.9z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.36
    },
    width: 132,
    height: 109,
    xlinkHref: "26F8CFCD.png",
    transform: "matrix(1 0 0 1 184 136)"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M299.1,232.3H201c-2.2,0-4-1.8-4-4v-75.7c0-2.2,1.8-4,4-4h98.1c2.2,0,4,1.8,4,4v75.7 C303.1,230.5,301.3,232.3,299.1,232.3z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_891_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st25",
    d: "M203.2,199.6c2.8,0.3,5.7,0.5,8.5,0.8c4.3,0.4,8.6,0.8,13,1.2c0.6,0.1,1.2,0.1,1.8,0.2 c0.2,0,0.5,0.1,0.7,0c0.2,0,0.4-0.2,0.6-0.3c0.5-0.3,0.9-0.6,1.4-0.9c3.6-2.3,7.1-4.5,10.7-6.8c3.1-2,6.2-3.9,9.3-5.9 c0.2-0.1,0.4-0.3,0.7-0.4c-0.1,0.1-0.1,0,0,0c0.1,0,0.3,0,0.4,0c1.5,0.1,2.9,0.3,4.4,0.4c4.5,0.4,9,0.8,13.6,1.2 c1.5,0.1,2.9,0.2,4.4,0.4c0.5,0,0.9,0,1.4-0.1c3.8-0.8,7.5-1.7,11.3-2.5c3.7-0.8,7.3-1.6,11-2.5c0.2,0,0.4-0.1,0.6-0.1 c0.3-0.1,0.2-0.5-0.1-0.5c-2.7,0.6-5.5,1.2-8.2,1.8c-4.3,1-8.6,1.9-12.9,2.9c-0.6,0.1-1.2,0.3-1.8,0.4c-0.2,0.1-0.5,0.1-0.8,0.2 c0.1,0,0,0-0.1,0c-0.2,0-0.3,0-0.5,0c-0.6-0.1-1.2-0.1-1.8-0.2c-4.3-0.4-8.7-0.7-13-1.1c-1.9-0.2-3.9-0.3-5.8-0.5 c-0.6,0-1.1-0.1-1.7-0.1c-0.2,0-0.4-0.1-0.6,0c-0.2,0.1-0.4,0.3-0.6,0.4c-0.5,0.3-1,0.6-1.5,0.9c-1.6,1-3.2,2-4.8,3.1 c-3.9,2.4-7.7,4.9-11.6,7.3c-1.2,0.7-2.4,1.5-3.5,2.2c-0.1,0.1-0.3,0.2-0.4,0.2c0,0-0.2,0.1-0.1,0.1c0.1,0-0.1,0-0.1,0 c-0.2,0-0.3,0-0.5,0c-3.8-0.4-7.5-0.7-11.3-1.1c-3.8-0.4-7.5-0.7-11.3-1.1c-0.2,0-0.4,0-0.6-0.1 C202.9,199.1,202.9,199.6,203.2,199.6L203.2,199.6z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_890_",
    className: "st26",
    cx: 203.2,
    cy: 199.4,
    r: 1.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_889_",
    className: "st27",
    d: "M228.1,201.6c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1 S228.1,201,228.1,201.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_888_",
    className: "st28",
    cx: 249.7,
    cy: 187.3,
    r: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_887_",
    className: "st26",
    cx: 272.9,
    cy: 189.4,
    r: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_884_",
    className: "st28",
    d: "M298,184.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1 S298,183.4,298,184.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.1,160.7H197v-8.2c0-2.2,1.8-4,4-4h98.1c2.2,0,4,1.8,4,4V160.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000061455835003257777040000015373674346569389759_",
    className: "st27",
    d: "M205.8,154.6c0,0.9-0.7,1.6-1.6,1.6 s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6S205.8,153.7,205.8,154.6z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_00000147183027642240576280000011595096323800605588_",
    className: "st28",
    cx: 209.4,
    cy: 154.6,
    r: 1.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_00000000933509093295105450000002506048068497716142_",
    className: "st26",
    cx: 214.7,
    cy: 154.6,
    r: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M231.3,182.9h-23.2c-0.6,0-1-0.4-1-1v-8.6c0-0.6,0.4-1,1-1h23.2c0.6,0,1,0.4,1,1v8.6 C232.3,182.5,231.8,182.9,231.3,182.9z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M212.6,178.8c0.3,0.2,0.7,0.3,1.2,0.3c0.6,0,0.9-0.3,0.9-0.7c0-0.4-0.3-0.6-0.9-0.8 c-0.8-0.3-1.4-0.7-1.4-1.5c0-0.8,0.7-1.4,1.8-1.4c0.5,0,0.9,0.1,1.2,0.2l-0.2,0.7c-0.2-0.1-0.5-0.2-1-0.2c-0.6,0-0.8,0.3-0.8,0.6 c0,0.4,0.3,0.6,1,0.8c0.9,0.3,1.3,0.8,1.3,1.5c0,0.8-0.6,1.5-1.9,1.5c-0.5,0-1.1-0.2-1.4-0.3L212.6,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M219.4,177.6h-1.9v1.5h2.1v0.8h-3v-5h2.9v0.8h-2v1.3h1.9V177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M220.4,174.8h0.9v4.3h2.1v0.8h-3V174.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M224.1,174.8h0.9v4.3h2.1v0.8h-3V174.8z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M297.1,217.7h-23.2c-0.6,0-1-0.4-1-1v-8.6c0-0.6,0.4-1,1-1h23.2c0.6,0,1,0.4,1,1v8.6 C298.1,217.3,297.6,217.7,297.1,217.7z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M279.2,209.7c0.3-0.1,0.8-0.1,1.3-0.1c0.7,0,1.1,0.1,1.4,0.3c0.3,0.2,0.5,0.5,0.5,0.9 c0,0.5-0.3,0.9-0.8,1.1v0c0.5,0.1,1,0.6,1,1.2c0,0.4-0.2,0.8-0.5,1c-0.4,0.3-0.9,0.5-1.9,0.5c-0.5,0-0.9,0-1.1-0.1V209.7z  M280.2,211.7h0.5c0.6,0,1-0.3,1-0.7c0-0.5-0.4-0.7-0.9-0.7c-0.3,0-0.4,0-0.5,0V211.7z M280.2,214c0.1,0,0.3,0,0.5,0 c0.6,0,1.1-0.2,1.1-0.8c0-0.6-0.5-0.8-1.1-0.8h-0.5V214z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M284.5,209.6v2.9c0,1,0.4,1.4,1,1.4c0.7,0,1.1-0.5,1.1-1.4v-2.9h0.9v2.9c0,1.6-0.8,2.2-2,2.2 c-1.2,0-1.9-0.7-1.9-2.2v-2.9H284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M289.7,214.6v-2.1l-1.6-2.9h1.1l0.6,1.3c0.2,0.4,0.3,0.7,0.4,1h0c0.1-0.3,0.3-0.6,0.4-1l0.6-1.3h1l-1.7,2.9 v2.1H289.7z"
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st30",
    points: "203.2,208 226.5,196.8 255.4,190.5 272.9,199.4 296.8,176.6  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M222,219.1h9.5c0,5.2-4.3,9.5-9.5,9.5s-9.5-4.3-9.5-9.5c0-5.2,4.3-9.5,9.5-9.5c0.2,0,0.3,0,0.5,0L222,219.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M222.3,218.8l0.6-9.5c2.4,0.2,4.6,1.2,6.3,2.9c1.7,1.7,2.6,4,2.6,6.4L222.3,218.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdpiBanner1);
export default __webpack_public_path__ + "static/media/ddpi-banner1.a9f78fe06798e4d6c620abca2af8ff98.svg";
export { ForwardRef as ReactComponent };